<template>
    <vs-col :style="{'text-align': $i18n.locale === 'ar' ? 'right' : '','direction': $i18n.locale === 'ar' ? 'rtl' : ''}"  vs-lg="12" vs-xs="12" class="p-1" type="flex" id="counter-statistics-box">
      <vs-card id="form">
        <vs-tabs>
          <span v-if="!isLoading && counters">
          <div style=";display: flex; justify-content: left;padding-bottom: 20px">
            <vs-select
                :danger="false"
                :label="$t('Components.Queue.TicketItem.Counters')"
                :placeholder="$t('Booking.CreatePrompt.counterPlaceholder')"
                style="margin:auto;width:25%"
                multiple
                v-model="selectedCounters"
                @change="setSelectedCounters"
            >
              <vs-select-item
                  :key="index"
                  :value="counter.id"
                  :text="counter.name"
                  v-for="(counter, index) in counters"
              />
            </vs-select>
            <vs-select
                :danger="false"
                :danger-text="$t('Errors.Required', { field: $t('services') })"
                :placeholder="$t('Booking.CreatePrompt.ServicePlaceholder')"
                class="w-50"
                autocomplete
                :label="$t('Booking.Table.Services')"
                multiple
                style="margin:auto;"
                v-model="selectedServices"
                @change="changed = true,servicesChanged = true"
            >
          <vs-select-item
              :key="index"
              :value="item.service_id"
              :text="item.title"
              v-for="(item, index) in services"
          />
        </vs-select>

             <vs-button
                 style="height: 40px;margin: auto;min-width: 200px;font-size: 17px;margin-top: 27px"
                 @click="loadStatistics"
                 :disabled="!changed || loadingFeedbackStatistics || loadingCounterStatistics || isLoading"
                 color="primary"
                 class="pr-1 pl-1"
             >
        {{ $t("Feedbacks.Filter.filterButton") }}
      </vs-button>
          </div>
          </span>
          <div style="display: flex;width: 100%;justify-content: center;height: 100px" v-else-if="isLoading">
            <div class="spinner-border text-primary" style="margin: auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <br>
          <div v-if="statisticsData && !loadingCounterStatistics" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" class="title">{{ $t("Statistics.ServicesTable.firstTitle") }}</div>
          <br>
          <vs-table
              v-if="statisticsData && !loadingCounterStatistics"
              :sst="true"
              max-items="10"
              :data="statisticsData"
          >
            <template slot="thead">
              <vs-th sort-key="contactname">{{ $t("Statistics.ServicesTable.Service") }}</vs-th>
              <vs-th sort-key="contactname">{{ $t("Statistics.ServicesTable.Counter") }}</vs-th>
              <vs-th sort-key="joindate">{{ $t("Statistics.ServicesTable.Estimated") }}</vs-th>
              <vs-th sort-key="phone">{{ $t("Statistics.ServicesTable.CarriedOut") }}</vs-th>
              <vs-th sort-key="lbrx_id">{{ $t("Statistics.ServicesTable.Difference") }}</vs-th>
              <vs-th sort-key="book_id">{{ $t("Statistics.ServicesTable.Count") }}</vs-th>
            </template>

            <template>
              <vs-tr :key="index" v-for="(service, index) in statisticsData">
                <vs-td sort-key="contactname"><b>{{service.translations != null && JSON.parse(service.translations)[$i18n.locale] != null ? JSON.parse(service.translations)[$i18n.locale] : service.Operation }}</b></vs-td>
                <vs-td sort-key="contactname">{{service.guichet != null ? service.guichet : "--"}}</vs-td>
                <vs-td sort-key="contactname" :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}">{{service.Duree}}{{$t('Statistics.minutes')}}</vs-td>
                <td :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}">
                  {{service.Moyenne.split('.')[0]}}{{$t('Statistics.minutes')}}
                  {{service.Moyenne.split('.')[1]>0?( Math.floor( (service.Moyenne.split('.')[1]/100)*0.6 ) )+$t('Statistics.seconds'):''}}</td>
                <vs-td sort-key="contactname" v-if="service.Difference>0" class="text-danger" style="direction: ltr !important;"><b>+{{service.Difference}}%</b></vs-td>
                <vs-td sort-key="contactname" style="direction: ltr !important;" v-else class="text-success"><b>{{service.Difference}}%</b></vs-td>
                <vs-td sort-key="contactname">{{service.count}}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div style="display: flex;width: 100%;justify-content: center;height: 100px" v-if="loadingCounterStatistics">
            <div class="spinner-border text-primary" style="margin: auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <br>
          <div v-if="feedbackstatisticsData && !loadingFeedbackStatistics" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" class="title">{{ $t("Statistics.ServicesTable.secondTitle") }}</div>
          <br>
          <vs-table
              v-if="feedbackstatisticsData && !loadingFeedbackStatistics"
              :sst="true"
              max-items="10"
              :data="feedbackstatisticsData"
          >
            <template slot="thead">
              <vs-th sort-key="contactname">{{ $t("Statistics.ServicesTable.Service") }}</vs-th>
              <vs-th sort-key="joindate">{{ $t("Statistics.ServicesTable.TotalFeedback") }}</vs-th>
              <vs-th :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}" style="min-width:120px" sort-key="phone">
                {{ $t("Statistics.ServicesTable.average") }}
              </vs-th>
              <vs-th :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}" style="min-width:140px" sort-key="phone">
                {{ $t("Statistics.ServicesTable.totalAvg") }}
              </vs-th>
              <vs-th :style="{'direction': $i18n.locale === 'ar' ? 'rtl' : ''}" style="min-width:150px" sort-key="phone">
                {{ $t("Statistics.ServicesTable.difference") }}
              </vs-th>
            </template>
            <template>
              <vs-tr :key="index" v-for="(service, index) in feedbackstatisticsData">
                <vs-td sort-key="contactname"><b>{{service.translations != null && JSON.parse(service.translations)[$i18n.locale] != null ? JSON.parse(service.translations)[$i18n.locale] : service.Operation }}</b></vs-td>
                <vs-td sort-key="contactname" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" class="text-primary">{{service.total != null ? service.total : "--"}}</vs-td>
                <vs-td sort-key="contactname" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" class="text-warning"><b>
                  {{service.avg != null ? parseFloat(service.avg).toFixed(1) : "--"}}</b>
                  <i class="mdi mdi-star rating-star-small text-warning"></i>
                </vs-td>
                <vs-td sort-key="contactname" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" class="text-warning"><b>
                  {{service.avg_total != null ? parseFloat(service.avg_total).toFixed(1) : "--"}}</b>
                  <i class="mdi mdi-star rating-star-small text-warning"></i>
                </vs-td>
                <vs-td sort-key="contactname" :style="{'text-align': $i18n.locale === 'ar' ? 'right' : ''}" style="direction: ltr !important;" :class="{'text-success': service.difference >= 0, 'text-danger': service.difference < 0}"><b>{{service.difference != null ? parseFloat(service.difference).toFixed(0) : "--"}}%</b></vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div style="display: flex;width: 100%;justify-content: center;height: 100px" v-if="loadingFeedbackStatistics">
            <div class="spinner-border text-primary" style="margin: auto" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </vs-tabs>
      </vs-card>
    </vs-col>
</template>

<script>
import 'vue2-datepicker/index.css';
import {counterService, privateServiceService, statisticsService} from "@/_services";

export default {
  name:"CounterStatistics",
  data:() => ({
    isLoading: false,
    selectedCounters:null,
    counters:null,
    selectedServices:null,
    services:null,
    statisticsData: null,
    changed:true,
    servicesChanged:true,
    loadingCounterStatistics:false,
    loadingFeedbackStatistics:false,
    feedbackstatisticsData:false,
  }),
  props : {
    startLoading:Boolean,
    dataRange:Array,
  },
  emits: ['doneLoading'],
  watch: {
    startLoading(newValue) {
      if(newValue) {
        this.servicesChanged = true;
        if(this.counters == null || this.counters.length === 0 || this.services == null || this.services.length === 0) {
          this.isLoading = true;
          this.loadCounters();
        } else {
          this.loadStatistics()
        }
      }
    }
  },
  components:{

  },
  methods:{
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = date.getDate().toString().padStart(2, '0');
      return`${year}-${month}-${day}`;
    },
    getStartDate(month) {
      const [year, monthPart] = month.split('-');
      const startDate = new Date(`${year}-${monthPart}-01 00:00:00`);
      return this.formatDate(startDate);
    },
    getEndDate(month) {
      const [year, monthPart] = month.split('-');
      const lastDay = new Date(year, monthPart, 0);
      const endDate = new Date(`${year}-${monthPart}-${lastDay.getDate()} 23:59:59`);
      return this.formatDate(endDate);
    },
    setSelectedCounters() {
      this.changed = true;
      if(this.selectedCounters.length > 1 ) {
        if(this.selectedCounters.indexOf(-1) === 0) {
          this.selectedCounters.splice(this.selectedCounters.indexOf(-1), 1);
        } else if(this.selectedCounters.indexOf(-1) !== -1) {
          this.selectedCounters= [-1];
        }
      }
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },
    loadFeedback(payload) {
      this.loadingFeedbackStatistics = true;
      statisticsService.loadCounterFeedback(payload).then((data)=> {
        this.feedbackstatisticsData = data;
      }).catch(()=> {
        this.notify(
            this.$t("Toasts.Error"),
            this.$t("Error loading counter feedback statistics!"),
            "danger"
        );
      }).finally(()=> {
        this.changed = false;
        this.loadingFeedbackStatistics = false;
        this.$emit('doneLoading');
      })
    },
    loadStatistics() {
      this.statisticsData = null;
      this.loadingCounterStatistics = true;
      const payload = {};
      if(this.selectedCounters.length && this.selectedCounters[0] !== -1) {
        payload.counter = this.selectedCounters.toString();
      }
      if(this.selectedServices.length) {
        payload.services = this.selectedServices.toString();
      }
      payload.start = this.getStartDate(this.dataRange[0]);
      payload.end = this.getEndDate(this.dataRange[1]);
      statisticsService.loadCounterServiceDuration(payload).then((data)=> {
        this.statisticsData = data;
      }).catch(()=> {
        this.notify(
            this.$t("Toasts.Error"),
            this.$t("Error loading counter statistics!"),
            "danger"
        );
      }).finally(()=> {
        this.loadingCounterStatistics = false;
        if(this.servicesChanged) {
          this.loadFeedback(payload);
          this.servicesChanged = false;
        } else {
          this.changed = false;
        }
      })
    },
    loadCounters() {
      counterService.getAllByBusiness().then((data)=> {
        this.counters = data.counters;
        this.counters.unshift({id: -1,name: this.$t("Statistics.AllQueues")});
        this.selectedCounters = [];
        this.selectedCounters[0]=this.counters[0].id;
        this.loadServices();
      }).catch(()=> {
        this.isLoading = false;
        this.notify(
            this.$t("Toasts.Error"),
            this.$t("Error loading counters list!"),
            "danger"
        );
      }).finally(()=> {
        this.isLoading = false;
      })
    },
    loadServices() {
      privateServiceService.getAll().then((data)=> {
        this.services = data.services;
        this.selectedServices = [];
        this.loadStatistics();
      }).catch((err)=> {
        this.isLoading = false;
        this.notify(
            this.$t("Toasts.Error"),
            this.$t("Error loading services list!"),
            "danger"
        );
      })
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.rating-star-small {
  font-size: unset !important;
}
.title{
  font-size: 20px;
  font-weight: bold;
  background: #008fc9;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  margin-bottom: 10px;
}
</style>